<template>
  <div class="announcement-detail">
    <Spin v-if="!model.title"></Spin>
    <div class="announce-container" v-else>
      <div class="announce-header">
        <div class="title">{{ model.title }}</div>
        <Divider />
        <div class="info">
          <span class="font-grey small origin" v-if="model.origin">来源：{{ model.origin }}</span>
          <span class="font-grey small author">发布人：{{ model.announcerName }}</span>
          <span class="font-grey small time" v-if="model.createTime">时间：{{ getMoment(model.createTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
          <span class="font-grey small author">阅读：{{ model.viewCount }}</span>
        </div>
      </div>
      <div class="announce-body" v-if="model.contentType===0">{{ model.content }}</div>
      <div class="announce-body" v-else v-html="model.content"></div>
      <div class="announce-attchments" v-if="model.attachments.length">
        <Divider orientation="left"><Icon type="md-attach" />&nbsp;附件</Divider>
        <ul>
          <li
            @click="previewUploaded(att)"
            v-for="(att,attidx) in model.attachments"
            :key="attidx">
            {{ att }}
          </li>
        </ul>
      </div>
      <div class="announce-refer" v-if="model.refer">
        <a :href="model.refer" target="_blank">查看原文</a>
      </div>
    </div>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
import moment from 'moment'
export default {
  name: 'announcement-detail',
  props: {
  },
  data () {
    return {
      loading: false,
      model: {
        id: null,
        type: 0,
        title: null,
        contentType: 0,
        content: null,
        attachments: [],
        viewCount: 0,
        announcerId: null,
        announcerName: null,
        origin: null,
        refer: null,
        isTop: false,
        isPublic: true,
        createTime: null
      },
      previewImgUrl: null,
      showPreview: false,
    }
  },
  watch: {
    '$route.params.id': function (newVal) {
      if (newVal) {
        this.getDetail()
      }
    },
  },
  mounted () {
    if (this.$route.params.id) {
      this.getDetail()
    } else {
      this.$Modal.error({
        title: '错误',
        content: '编号为空',
        onOk: () => {
          this.$router.back()
        }
      })
    }
  },
  activated () {
  },
  deactivated () {
  },
  computed: {
  },
  methods: {
    getMoment (dt) {
      return moment(dt)
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    getDetail () {
      Api.Announcement.detail(this.$route.params.id).then(async (res) => {
        if (res.attachments) {
          let attaches = []
          try {
            attaches = JSON.parse(res.attachments)
          } catch (e) {
            attaches = []
          }
          res.attachments = attaches
        }
        Object.assign(this.model, res)
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    previewUploaded (file) {
      let key = file.indexOf('oss:') === 0 ? file.substr(4) : file
      this.procOssKey(key).then((obj) => {
        console.log(obj)
        if (obj.type === 'image') {
          this.previewImgUrl = obj.url
          this.showPreview = true
        } else {
          window.open(obj.url, '_blank')
        }
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve) => {
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        resolve({
          name: k,
          url,
          type,
          surfix
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.announce-header {
  margin-bottom: 30px;
  .title {
    color: #454545;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    padding-top: 16px;
  }
  .info {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    & > span {
      margin: 0 5px;
    }
  }
}
.announce-body {
  padding: 20px;
  white-space: pre-wrap;
}
.announce-attchments {
  margin-top: 120px;
  & > ul {
    list-style: none;
    & > li {
      border-radius: 5px;
      margin-bottom: 10px;
      padding: 5px 10px;
      background: #f9f9f9;
      border: 1px solid #e6e6e6;
      cursor: pointer;
      transition: all .2s linear;
      &:hover {
        background: fade(desaturate(@primaryColor, 50%), 20%);
        border: 1px solid @primaryColor;
      }
    }
  }
}
</style>
